export default "__VITE_ASSET__7e49a962__"